var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "episodes"
  }, [_c('h4', [_vm._v("Episodes")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.episodes), function(episode) {
    return _c('tr', {
      key: episode.episodeId
    }, [_c('td', {
      attrs: {
        "width": "64"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'Episode',
          params: {
            number: episode.number
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.episodeThumbnail(episode.artworkUrl),
        "alt": 'Show #' + episode.number,
        "width": "64"
      }
    })])], 1), _vm._v(" "), _c('td', [_c('h5', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Episode',
          params: {
            number: episode.number
          }
        }
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col"
    }, [_vm._v("Show #" + _vm._s(episode.number))]), _vm._v(" "), (episode.broadcastedAt) ? _c('div', {
      staticClass: "col text-right"
    }, [_vm._v(_vm._s(_vm.episodeDate(episode.broadcastedAt)))]) : _vm._e()])])], 1), _vm._v(" "), _c('ul', {
      staticClass: "list-unstyled"
    }, _vm._l((_vm.playlistsForEpisode(episode.episodeId)), function(playlist) {
      return _c('li', {
        key: playlist.playlistId
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'Playlist',
            params: {
              id: playlist.playlistId
            }
          }
        }
      }, [_vm._v("\n              " + _vm._s(playlist.name) + "\n            ")]), _vm._v(" "), _c('small', {
        staticClass: "text-secondary"
      }, [_vm._v(_vm._s(playlist.trackCount) + " tracks")])], 1)
    })), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": {
          name: 'Episode',
          params: {
            number: episode.number
          }
        }
      }
    }, [_c('small', [_vm._v(_vm._s(episode.tracks.length) + " total tracks")])])], 1)])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-567a8a1a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Episodes.vue
// module id = 2IGx
// module chunks = 1